const UnAssignedBatchLeadsTableHeader = [
  {
    field: 'sl_no',
    headerName: 'Sl No',
    flex: 0.5,
    minWidth: 80,
  },
  {
    field: 'admissionNo',
    headerName: 'Admission No',
    flex: 1,
    minWidth: 130,
  },
  {
    field: 'studentName',
    headerName: 'Student Name',
    flex: 1.5,
    minWidth: 200,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    flex: 1.2,
    minWidth: 150,
  },
  {
    field: 'courseName',
    headerName: 'Course',
    flex: 2,
    minWidth: 250,
  },
  {
    field: 'class',
    headerName: 'Class',
    flex: 0.8,
    minWidth: 100,
    valueGetter: (params) => params.row.class || '-',
  },
  {
    field: 'syllabus',
    headerName: 'Syllabus',
    flex: 1,
    minWidth: 130,
    valueGetter: (params) => params.row.syllabus || '-',
  },
  {
    field: 'studentRegion',
    headerName: 'Region',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'ogaName',
    headerName: 'OGA Name',
    flex: 1.5,
    minWidth: 180,
  },
  {
    field: 'cro_lead_status_name',
    headerName: 'Lead Status',
    flex: 1.2,
    minWidth: 150,
  },
  {
    field: 'course_enrollment_status',
    headerName: 'Enrollment Status',
    flex: 1,
    minWidth: 150,
    renderCell: (params) => {
      const statusMap = {
        1: 'Active',
        0: 'Inactive',
        2: 'Temporary Inactive',
      };

      return statusMap[params.value] || '-';
    },
  },
];

export default UnAssignedBatchLeadsTableHeader;
